export default __webpack_public_path__ + "static/mobile-cb9101f12c70b0e50d5370a527d7aa26.png";